<template>
   <v-menu               
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"                           
        transition="scale-transistion"
        offset-y
        min-width="auto"                            
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Date of Birth"                                            
                readonly
                v-bind="attrs"
                v-on="on"
                :max="new Date().toISOString().substr(0, 10)"
            >
            </v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            :active-picker.sync="activePicker"
            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
            min="1950-01-01"
            @change="save"
        >                                
        </v-date-picker>                            
    </v-menu>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        initialDate: {
            type: String,
            default: ''
        }
    },
    data: function(){
        return {
            activePicker: null,
            date: this.initialDate,
            menu: false,
        }
    },
    watch: {
        menu (val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
    },
    methods: {
        save (date) {
            this.$refs.menu.save(date)
            this.$emit('change-date', this.date); 
        },
    },
}
</script>